import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AgeVerificationPopup.css';

const AgeVerificationPopup = ({ onAccept, onReject, showDenied }) => {

const handleAcceptClick = () => {
  if (onAccept) onAccept();

  document.cookie = `popupVerified=1; path=/; max-age=300; domain=.southernhillsplay.site; secure; samesite=None`;

  
};

  return (
<div className="verification-popup">
  {!showDenied ? (
    <div className="popup-content">
      <h2>🔞 Before you play</h2>
      <h3>Welcome to Southernhillsplay!</h3>
      <p>This social casino game is developed for entertainment purposes only.</p>

      <ul className="feature-list">
        <li><span>❌</span> No </li>
        <li><span>❌</span> No </li>
        <li><span>✅</span> 100% </li>
        <li><span>🔞</span> For users over 18 only</li>
        <li><span>🧠</span> Play responsibly</li>
      </ul>

      <p className="consent-text">
        By clicking Accept, you confirm that you are over 18 years old and agree to our:
      </p>
      <ul className="terms-list">
        <li><Link to="/disclaimer" target="_blank" rel="noopener noreferrer">Disclaimer</Link></li>
        <li><Link to="/ansvarlig-spilling" target="_blank" rel="noopener noreferrer">Responsible Gaming</Link></li>
        <li><Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link></li>
      </ul>

      <div className="popup-buttons">
        <button className="accept-button" onClick={handleAcceptClick}>Accept Privacy Policy</button>
        <button className="reject-button" onClick={onReject}>Reject</button>
      </div>
    </div>
  ) : (
    <div className="popup-content denied">
      <h2>⚠️ Access Denied</h2>
      <p>You have chosen not to accept our terms.</p>
      <p>Therefore, you will not have access to the content on this page.</p>
      <p>Southernhillsplay is a free social casino platform for entertainment only and for users over 18 years old.</p>
      <p>No real money, no betting, and no prizes are offered.</p>
      <p className="redirect-text">🔙 Redirecting to the homepage...</p>
    </div>
  )}
</div>

  );
};

export default AgeVerificationPopup;
